import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnInit,
    Optional,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {HttpClient} from "@angular/common/http";
import {NestedTreeControl} from "@angular/cdk/tree";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatDrawer} from '@angular/material/sidenav';
import {VgApiService} from "@videogular/ngx-videogular/core";
import {faFolder, faFolderOpen} from "@fortawesome/free-solid-svg-icons";
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {ToastrService} from "ngx-toastr";
import {forkJoin, Observable, of, Subject, Subscription, switchMap} from "rxjs";
import {delay, map} from "rxjs/operators";
import {SpecialCompbaser} from "../compbaser";
import {IAppStatic} from "../../interfaces";
import {LocalStoreService, StoreSelectorsService} from "../../services";
import {timeout} from "../../decorators/timeout";
import {HOST_DIR, traverseTree} from "../../common";
import {TutorialsService} from "../../services/tutorials.service";

interface ITip {
    time: number;
    duration: number;
    link: string;
    name: string;
}

interface TreeData {
    name: string;
    iconname: string;
    url?: string;
    audio?: string;
    vtt?:string;
    videoid?: string;
    children?: TreeData[];
    tips?: Array<ITip>;
    lesson?: boolean;
    whiteLabel?: boolean;
    nextVideoId?: string;
}

const getChildren = (node: TreeData) => of(node.children);

@Component({
    selector: 'app-tutorials',
    templateUrl: './tutorials.component.html',
    styleUrls: ['./tutorials.component.scss']
})
export class TutorialsComponent extends SpecialCompbaser implements OnInit {
    readonly faFolder = faFolder;
    readonly faFolderOpen = faFolderOpen;

    private appSettings: IAppStatic;

    clickTimeout;

    lessonMode = false;
    selectedTabIndex = 0;
    lessonVideoId;
    //globalVideoId;

    tutorials;

    videoSource: string;
    audioSource: string;
    vttSource: string;
    showTips = false;
    normalMode = true;
    selectedTreeData: TreeData;
    videoUrl: string;
    videoSubscriber: Subscription;
    tips: Array<ITip> = [];
    toggleIcon = true;
    treeControl = new NestedTreeControl(getChildren);
    dataSource = new MatTreeNestedDataSource<TreeData>();
    searchVideos: TreeData[] = [];
    vgAPI: VgApiService;
    showManual = false;
    filter = "";
    activeVideoId = "";

    isVideoEnded = false;

    maxAudioGap = 0.1;

    currentSubtitle = '';

    videoReady$: Subject<any>;
    audioReady$: Subject<any>;
    vttReady$: Subject<any>;
    videoInit = null;

    watchedVideoLinks;

    @ViewChild("copyUrlModal", {read: TemplateRef}) copyUrlModal: TemplateRef<any>;
    @ViewChild("sidenav") sidenav: MatDrawer;

    @ViewChild("videoElement") videoElement: ElementRef;
    @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;


    @Input()
    set setAutoPlayVideoId(i_autoPlayVideoId: string) {
        console.log("videoId = " + i_autoPlayVideoId);
        if (i_autoPlayVideoId == null) {
            this.tutorialsService.getData().subscribe(data => {
                this.tutorials = data;
                this.selectTreeNode();
                this.selectedTabIndex = 1;
            });
        } else {
            this.activeVideoId = i_autoPlayVideoId;
            this.showManual = true;
            this.startVideo();
            setTimeout(() => {
                this.showManual = false;
            }, 5000);
        }
    }

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) data,
        @Optional() private dialogRef: MatDialogRef<any>,
        private route: ActivatedRoute,
        private _http: HttpClient,
        private translocoService: TranslocoService,
        private storeSelector: StoreSelectorsService,
        private localStoreService: LocalStoreService,
        private tutorialsService: TutorialsService,
        private toastr: ToastrService,
        dialog: MatDialog) {
        super(dialog);


        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                const videoId = routeParams.get('video_id');
                if (!videoId) return;
                this.activeVideoId = videoId;
            })
        );
        this.cod(
            this.storeSelector.getAppSettings().subscribe((appSettings: IAppStatic) => {
                this.appSettings = appSettings;
                if (this.watchedVideoLinks == null) {
                    this.watchedVideoLinks = this.localStoreService.getStorageValConfig('watchedVideoLinks');
                    this.lessonVideoId = this.localStoreService.getStorageValConfig('lessonVideoId');
                    //this.globalVideoId = this.localStoreService.getStorageValConfig('globalVideoId');
                    if (this.watchedVideoLinks == null) {
                        this.watchedVideoLinks = {};
                    }
                    if (data) {
                        this.lessonMode = data.lessonMode;
                        let videoId = data.videoLink;
                        if (this.lessonMode) {
                            if (this.lessonVideoId == null) {
                                this.lessonVideoId = data.videoLink;
                            } else {
                                videoId = this.lessonVideoId;
                            }
                        } else {
                            /*
                            if (this.globalVideoId != videoId) {
                                this.watchedVideoLinks[videoId] = 0;
                            }

                             */
                        }
                        //this.globalVideoId = videoId;
                        this.normalMode = false;

                        this.activeVideoId = videoId;
                        this.startVideo();
                    }
                }
            })
        );


    }

    ngOnInit(): void {
    }


    onTabChange(event: any): void {
        if (event.index === 0) {
            this.lessonMode = true;
            this.updateLessonsMode();
        } else if (event.index === 1) {
            this.lessonMode = false;
        }
    }

    updateLessonsMode() {
        this.filter = '';
        this.searchVideos = [];
        let i = 1;
        traverseTree(this.dataSource.data, (x, y, n) => {
            if (n.videoid && n.name && n.lesson && this.searchVideos.findIndex((v) => v.videoid === n.videoid) === -1) {
                const node = JSON.parse(JSON.stringify(n));
                node.name = "Lesson " + i + ": " + node.name;
                this.searchVideos.push(node);
                i++;
            }
        });
    }

    searchTutorial() {
        if (this.filter.length < 2 || !this.dataSource) return;
        this.searchVideos = [];

        traverseTree(this.dataSource.data, (x, y, n) => {
            if (n.videoid && n.name &&
                n.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 &&
                this.searchVideos.findIndex((v) => v.videoid === n.videoid) === -1) {
                this.searchVideos.push(n);
            }
        });
    }


    selectTreeNode() {
        traverseTree(this.tutorials, (x, y, n) => {
            if (n.videoid && n.videoid === this.activeVideoId) {
                this.selectedTreeData = n;
            }
        });
        this.dataSource.data = [this.tutorials];
        if (this.activeVideoId) {
            this.expandNode(this.dataSource.data[0], this.activeVideoId);
        } else {
            this.treeControl.expand(this.dataSource.data[0]);
        }
    }

    private dialogMode(i_data) {
        this.normalMode = false;
        setTimeout(() => {
            //??? this.setAutoPlayVideoId = i_data.videoLink;
            this.playClick();
        }, 20);
    }

    exitDialogMode() {
        this.dialogRef.close();
    }

    onMinimized() {
        if (this.sidenav) {
            this.sidenav.close();
        }
    }

    onMaximized() {
        if (this.sidenav) {
            this.sidenav.open();
        }
    }

    private expandNode(data: TreeData, videoid: string): boolean {
        if (data.videoid === videoid) {
            return true;
        }
        if (!data.children || !data.children.length) {
            return false;
        }
        for (const node of data.children) {
            if (this.expandNode(node, videoid)) {
                this.treeControl.expand(data);
                return true;
            }
        }
        return false;
    }

    /** full screen for entire app not just video and support Dialogs **/
    goFullScreen() {
        // constructor(
        //    @Inject(DOCUMENT) private document: Document,
        // this.document.getElementsByTagName('body')[0].requestFullscreen();
    }

    onPlayerReady(api) {
        try {
            this.vgAPI = api;
            if (this.videoSubscriber)
                this.videoSubscriber.unsubscribe();
            this.videoSubscriber = this.vgAPI.subscriptions.timeUpdate.pipe().subscribe(() => {
                if (this.selectedTreeData?.tips) {
                    this.tips = [];
                    this.selectedTreeData.tips.forEach((tip) => {
                        if (this.vgAPI.currentTime > tip.time && this.vgAPI.currentTime < (tip.time + tip.duration)) {
                            this.tips.push(tip);
                            this.tipOpenDialog();
                        }
                    });
                    if (this.tips.length === 0)
                        this.onCloseTip();
                } else {
                    this.onCloseTip();
                }
            });
        } catch (e) {
            debugger;
        }
    }

    onCloseTip() {
        this.tips = [];
        this.showTips = false;
    }

    tipOpenDialog() {
        this.showTips = true;
    }

    playClick() {
        this.showManual = false;
    }


    onOpenLink(i_url?) {
        const url = i_url ?? this.videoUrl;
        window.open(url, "_blank");
    }


    openModal(node) {
        this.videoUrl = `${this.appSettings.protocol}${this.appSettings.masterServer}/${HOST_DIR}/shopping-cart/helpdesk/${node.videoid}`;
        this.dialog.open(this.copyUrlModal);
    }



    copyText() {
        this.toastr.info(this.translocoService.translate('toast.copiedToClip', {}, this.translocoService.getActiveLang()));
        //     navigator.clipboard.writeText(this.videoUrl).then(() => {
        //     }, (err) => {
        //         console.error('Async: Could not copy text: ', err);
        //     });
    }



    clickedLeaf(e) {
        this.clickTimeout = setTimeout(() => {
            this.clickTimeout = null;
            console.log("Single click executed");
            // Your single click logic here

            this.activeVideoId = e.videoid;
            if (this.lessonMode) {
                this.lessonVideoId = this.activeVideoId;
            }
            //this.globalVideoId = this.activeVideoId;

            if (this.watchedVideoLinks[this.activeVideoId] == 100) {
                this.watchedVideoLinks[this.activeVideoId] = 0;
            }

            this.saveStorage();


            this.selectedTreeData = e;
            this.showManual = false;
            this.videoSource = null;
            this.audioSource = null;
            this.vttSource = null;
            this.currentSubtitle = '';
            this.startVideo();
        }, 300); // Adjust delay as needed
    }

    hasChild(_: number, node: TreeData) {
        return node.children != null && node.children.length > 0;
    }

    toggleVideoList() {
        if (this.sidenav) {
            this.sidenav.toggle();
        }
    }

    toggleVideoPane() {
        this.toggleIcon = !this.toggleIcon;
    }

    @timeout()
    startVideo() {
        console.log('startVideo');


        this.clearVideo();


        this.videoInit = this.tutorialsService.getData().pipe(

            switchMap(data => {
                this.tutorials = data;
                this.selectTreeNode();
                if (!this.lessonMode) {
                    this.selectedTabIndex = 1;
                }
                this.updateLessonsMode();

                return of('a');
            }),
            delay(500),
            switchMap( a => {
                if (this.selectedTreeData.url != null) {
                    this.videoSource = this.selectedTreeData.url;
                    this.audioSource = this.selectedTreeData.audio;
                    this.vttSource = this.selectedTreeData.vtt;
                } else {
                    const videoId = this.selectedTreeData.videoid;
                    this.videoSource = (`https://mstutorials.s3.us-west-2.amazonaws.com/${videoId}/video.mp4`).toLowerCase();
                    this.audioSource = (`https://mstutorials.s3.us-west-2.amazonaws.com/${videoId}/audio.mp3`).toLowerCase();
                    this.vttSource = (`https://mstutorials.s3.us-west-2.amazonaws.com/${videoId}/subtitle_en.vtt`).toLowerCase();
                }
                this.videoReady$ = new Subject<any>();
                const obsList = [this.videoReady$];

                if (this.audioSource != null) {
                    this.audioReady$ = new Subject<any>();
                    obsList.push(this.audioReady$);
                }

                if (this.vttSource != null) {
                    this.vttReady$ = new Subject<any>();
                    obsList.push(this.vttReady$);
                }



                return forkJoin(obsList);
            })
        ).subscribe( a => {
            this.videoInit = null;
            this.videoReady$ = null;
            this.audioReady$ = null;
            this.vttReady$ = null;
            this.videoElement.nativeElement.play();
            this.audioPlayer.nativeElement.volume = 1.0;
            this.maxAudioGap = 0.1;
        });



    }

    onVideoCreated() {
        const video: HTMLVideoElement = this.videoElement.nativeElement;
        if (video != null && this.watchedVideoLinks != null && this.watchedVideoLinks[this.activeVideoId] != null) {
            let percentage = Number(this.watchedVideoLinks[this.activeVideoId]);
            if (isNaN(percentage)) {
                percentage = 0;
            }
            video.currentTime = Math.max(0, (percentage / 100) * video.duration - 5);
        }
        const track = video.textTracks[0]; // Get the first text track
        if (track) {
            track.mode = 'hidden'; // Hide the default subtitles
        }
    }

    onVideoCanPlay() {
        if (this.videoReady$ != null) {
            this.videoReady$.next('Video is ready');
            this.videoReady$.complete();
            this.videoReady$ = null;
        }
    }

    onAudioCanPlay() {
        if (this.audioReady$ != null) {
            this.audioReady$.next('Audio is ready');
            this.audioReady$.complete();
            this.audioReady$ = null;
        }
    }

    onVttCanPlay() {
        if (this.vttReady$ != null) {
            this.vttReady$.next('vtt is ready');
            this.vttReady$.complete();
            this.vttReady$ = null;
        }
    }

    onSubtitle(event) {
        const track = this.videoElement.nativeElement.textTracks[0]; // Get the first text track
        const activeCue = track.activeCues?.[0]; // Get the active cue
        this.currentSubtitle = activeCue ? (activeCue as VTTCue).text : '';
    }

    onVideoPlay(): void {
        console.log('onVideoPlay')

        //this.audioPlayer.nativeElement.volume = 1.0;
    }

    // this function get call when user change the video time
    onVideoPause(): void {
        console.log("video pause");
        this.audioPlayer.nativeElement.volume = 0.0;
        this.maxAudioGap = 0.1;
    }

    onVideoSeek() {
        console.log('onVideoSeek');
        if (this.videoInit == null) {
            this.isVideoEnded = false;
            this.videoElement.nativeElement.play();
            this.audioPlayer.nativeElement.volume = 1.0;
        }
    }

    onVideoEnded() {
        this.saveStorage();

        this.currentSubtitle = '';
        if (this.selectedTreeData.nextVideoId) {
            this.isVideoEnded = true;
        }
    }

    onCancel() {
        this.isVideoEnded = false;
    }


    onVideoTimeUpdate(currentTime: number): void {
        this.updateProgress();
        const audio = this.audioPlayer.nativeElement;
        if (this.audioSource && audio != null) {
            if (Math.abs(audio.currentTime - currentTime) > this.maxAudioGap) {
                console.log('maxAudioGap: ' + this.maxAudioGap);
                this.maxAudioGap *= 2;

                console.log('onVideoTimeUpdate: ' + currentTime + ', ' + audio.currentTime);
                audio.currentTime = currentTime;

                if (audio.paused) {
                    console.log("audio.play()");
                    audio.play().catch(error => console.log("Playback error:", error));
                } else {
                    console.warn('audio already playing');
                }

            }
        } else {
            console.error(this.audioSource);
            console.error(audio);
        }

    }


    onPlayNext() {
        this.isVideoEnded = false;
        this.activeVideoId = this.selectedTreeData.nextVideoId;
        this.lessonVideoId = this.activeVideoId;
        this.watchedVideoLinks[this.activeVideoId] = 0;
        this.saveStorage();
        this.showManual = false;
        this.videoSource = null;
        this.audioSource = null;
        this.vttSource = null;
        this.currentSubtitle = '';
        this.startVideo();

    }

    getProgress(videoid) {
        if (this.watchedVideoLinks == null)
            return 0;

        if (this.watchedVideoLinks[videoid] == null || isNaN(Number(this.watchedVideoLinks[videoid]))) {
            return 0;
        }

        const progress =  this.watchedVideoLinks[videoid];
        return progress;
    }

    updateProgress() {
        if (this.watchedVideoLinks == null)
            return;

        if (this.videoElement != null) {
            const video = this.videoElement.nativeElement;
            const percentage = (video.currentTime / video.duration) * 100;
            this.watchedVideoLinks[this.activeVideoId] = percentage.toFixed(2);;
        }
    }

    saveStorage() {
        this.localStoreService.setStorageValConfig('watchedVideoLinks', this.watchedVideoLinks);
        if (this.lessonMode) {
            this.localStoreService.setStorageValConfig('lessonVideoId', this.lessonVideoId);
        }
        //this.localStoreService.setStorageValConfig('globalVideoId', this.globalVideoId);
    }

    clearVideo() {
        console.log('clearVideo');

        if (this.videoInit != null) {
            this.videoInit.unsubscribe();
            this.videoInit = null;
        }


        if (this.videoElement != null) {
            this.videoSource = '';
        }

        if (this.audioPlayer != null) {
            this.videoSource = '';
        }



    }

    override destroy() {
        super.destroy();

        this.clearVideo();

        if (this.watchedVideoLinks[this.activeVideoId] == 100) {
            if (this.selectedTreeData.nextVideoId != null) {
                this.activeVideoId = this.selectedTreeData.nextVideoId;
                this.lessonVideoId = this.activeVideoId;
            }
            this.watchedVideoLinks[this.activeVideoId] = 0;
        }

        this.saveStorage();

        if (this.videoSubscriber)
            this.videoSubscriber.unsubscribe();
    }
}
